/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SchemaDiffEnum } from "./SchemaDiffEnum";
export const SchemaDiffData = core.serialization.record(core.serialization.string(), SchemaDiffEnum);
